import { View } from "binder"
import { NullViewModel } from "./null-viewModel"

export class NullView extends View<NullViewModel>{
    GetViewUniqueId(): string {
        return "V-E47AFBB7-B701-4C0B-9480-D91BBF5BEBAC"
    }
    loadHtml(): string {
        let element = require('./null.html').default;
        let style = require('./null.less');
        return element;
    }
    constructor() {
       super();
    }
}
